module.exports = __webpack_public_path__ + "img/checkups.83a9ef01.svg";